<template>
  <div class="shop-item">
    <div class="shop-con" >
      <div class="img-con" @click="goSgShopIndex">
        <img class="img" :src="itemData.shopAvatar + '?imageView2/0/w/80/h/80'" alt="">
      </div>
      <div class="shop-name" @click="goSgShopIndex">{{ itemData.shopName }}</div>
    </div>

    <shop-goods-item
        v-for="(data, i) in itemData.goodsList"
        :key="data.goodsId"
        :itemData2="data"
    ></shop-goods-item>
    <div class="bg-10px"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import shopGoodsItem from '../shopGoodsItem'
import { introduce } from '@/api/mall/mallShop'
export default {
  props: {
    itemData: {
      required: true,
    },
  },
  components: {
    shopGoodsItem,
  },
  data(){
    return {
      shopChecked: false,
      isShopClick: false,//是否发生点击事件
      editShopSelected: false,
      goodsList: [],
      count: 1
    }
  },
  computed:{
    ...mapGetters([

    ])
  },
  watch: {
    itemData: {
      handler(newData, oldData) {
        this.shopChecked = newData.shopSelected
        this.editShopSelected = newData.editShopSelected
        this.goodsList = Object.assign([], newData.shopItems)
      },
      deep:true,
      immediate: true
    },
  },
  created(){

  },
  methods: {
    clickCheck(){
      this.isShopClick = true
    },
    goSgShopIndex(){
      if(this.cartEditState){return false}
      this.$router.push({ name: 'sgShopIndex', query: {shopId: this.itemData.shopId} })
    },
  }
}
</script>

<style lang="less" scoped>
.shop-item{
  font-size: 14px;color: #2b2b2b;
  .shop-con{
    display: flex;height: 50px;padding-left: 12px;border-bottom: 1px solid rgb(237,236,236);

    .img-con{
      display: inline-flex;justify-content: center;align-items: center;height: 100%;
      .img{width: 24px;height: 24px;border-radius: 50%;}
    }
    .shop-name{
      min-width: 150px;height: 100%;padding-left: 12px;
      display: inline-flex;justify-content: flex-start;align-items: center;
    }
  }
}
</style>